import { Column } from '@miq/catalog';
import { LocaleId } from '@shared/models/language.model';
import moment from 'moment';
import {
  getTermCalculationFunction,
  LeaseTermParams,
  UTC_EDP_INPUT_FORMAT,
  UTC_EDP_OUTPUT_FORMAT,
} from '../../../../business-rules/lease/lease-term-calc';
import { digger } from '@cbre/digger';

export enum Periods {
  Months = 'months',
  Years = 'years',
}

export enum LeaseColumnIds {
  StartDate = 1633,
  EndDate = 1635,
  LeaseTerm = 1636,
}

export function leaseTermCalcWithLocation(
  locale: LocaleId,
  changedColumn: Column,
  reportSection: LeaseTermParams,
  record: any
): Column {
  // If the value is cleaned out, set the calculation to false
  if (changedColumn.value == null || changedColumn.value === '') {
    return null;
  }
  // runCalculation is defaulted to doNothing and return empty
  let columnsToModify: Column;
  switch (changedColumn.columnId) {
    case LeaseColumnIds.StartDate: // Start date
      columnsToModify = leaseTermCalculation(reportSection, locale, columnsToModify);
      break;
    case LeaseColumnIds.LeaseTerm: // Lease term
      columnsToModify = startEndDateCalculation(reportSection, record);
      break;
    case LeaseColumnIds.EndDate: // End date
      columnsToModify = leaseTermCalculation(reportSection, locale, columnsToModify);
      break;
  }
  return columnsToModify == null ? null : columnsToModify;
}

function leaseTermCalculation(reportSection: LeaseTermParams, locale: number, columnsToModify: Column): Column {
  return reportSection.leaseTermColumn.value == null
    ? getTermCalculationFunction(reportSection, locale, true)
    : columnsToModify;
}

function startEndDateCalculation(reportSection: LeaseTermParams, record: any): Column {
  let result: Column;
  const recordLeaseTermUom = digger(record, 'ref_lease_term_std_uom_desc');
  const uomValue = !!reportSection.leaseTermColumn.unit.value
    ? reportSection.leaseTermColumn.unit.value
    : recordLeaseTermUom;
  const calculationType: string = !!Periods[uomValue] ? Periods[uomValue] : Periods.Months;
  if (reportSection.startDateColumn.value == null || reportSection.endDateColumn.value == null) {
    result =
      reportSection.startDateColumn.value == null
        ? getStartDateCalculationFunction(reportSection, calculationType)
        : getEndDateCalculationFunction(reportSection, calculationType);
  }
  return result;
}

function getEndDateCalculationFunction(reportSection: LeaseTermParams, type: string) {
  const endDate = moment(reportSection.startDateColumn.value, UTC_EDP_INPUT_FORMAT)
    .utc()
    .add(reportSection.leaseTermColumn.value, type)
    .subtract(1, 'days')
    .format(UTC_EDP_OUTPUT_FORMAT);
  reportSection.endDateColumn.value = endDate;
  return reportSection.endDateColumn;
}

function getStartDateCalculationFunction(reportSection: LeaseTermParams, type: string) {
  const startDate = moment(reportSection.endDateColumn.value, UTC_EDP_INPUT_FORMAT)
    .utc()
    .subtract(reportSection.leaseTermColumn.value, type)
    .add(1, 'days')
    .format(UTC_EDP_OUTPUT_FORMAT);
  reportSection.startDateColumn.value = startDate;
  return reportSection.startDateColumn;
}
